interface Environment {
    API_BASE_URL: string;
    REDSYS_URL: string;
}

const environments: { [key: string]: Environment } = {
    development: {
        API_BASE_URL: 'https://dev.reservas.hankyplanet.com/api/public',
        REDSYS_URL: 'https://sis-t.redsys.es:25443/sis/realizarPago'
    },
    production: {
        API_BASE_URL: 'https://reservas.hankyplanet.com/api/public',
        REDSYS_URL: 'https://sis.redsys.es/sis/realizarPago'
    }
};

const getEnvironment = (): Environment => {
    const env = process.env.REACT_APP_ENV;
    
    if (!env) {
        throw new Error('Environment not specified. Please set REACT_APP_ENV to either "development" or "production"');
    }
    
    if (!environments[env]) {
        throw new Error(`Invalid environment "${env}". Valid environments are: ${Object.keys(environments).join(', ')}`);
    }
    
    return environments[env];
};

export const config = getEnvironment(); 